import {IS_NONE, ONE_OF} from '../operators';

export default {
    categories: {
        programSelection: function (PROGRAMS) {
            return (function () {
                return {
                    id: 'program_selection',
                    label: 'Program Selection',
                    fields: [
                        {
                            id: 'program_selection',
                            name: 'program_selection',
                            label: 'Program Selection',
                            operators: {
                                [ONE_OF]: PROGRAMS.map(function (program) {
                                    // console.log(program);
                                    var start = moment(program.start).format('H:mm'),
                                        shortdate = moment(program.end).format('D MMM');
                                    return {
                                        id: program.id,
                                        value: program.id.toString(),
                                        label: program.name + ' (' + start + ' - ' + shortdate + ')',
                                    };
                                }),
                                [IS_NONE]: true,
                            },
                        },
                    ],
                };
            })();
        },
        userProfile: function (COLUMNS, AUTOCOMPLETE_URL) {
            return (function () {
                return {
                    id: 'user_profile',
                    name: 'user_profile',
                    label: 'User Profile',
                    fields: COLUMNS.map(function (col) {
                        var fetchAutocompleteSuggestions = function () {
                            return new Promise(function (resolve, reject) {
                                // resolve(['aaaa','bbbb','cccc','ddddd']);
                                // console.log('>>> FETCH SUGGESTIONS FROM >>>', AUTOCOMPLETE_URL + '?column_name=' + encodeURIComponent(col.id), col);
                                $.ajax({
                                    method: 'GET',
                                    url: AUTOCOMPLETE_URL + '?column_name=' + encodeURIComponent(col.id),
                                })
                                    .done(function (data) {
                                        resolve({
                                            suggestions: data.result.map(function (suggestion) {
                                                return suggestion[1];
                                            }),
                                            save: !data.has_more,
                                        });
                                    })
                                    .fail(function () {
                                        console.error(arguments);
                                    });
                            });
                        };
                        return {
                            id: col.id,
                            name: col.name,
                            label: col.label ?? col.name,
                            operators: {
                                equals: fetchAutocompleteSuggestions,
                                contains: fetchAutocompleteSuggestions,
                                isNone: true,
                            },
                        };
                    }),
                };
            })();
        },
    },
    preview: {
        useGlobalVar: function (qbElementSelector, previewURL) {
            return function (value) {
                $.ajax({
                    method: 'POST',
                    url: previewURL,
                    data: {
                        filter: JSON.stringify(value),
                    },
                })
                    .done(function (result) {
                        // console.log(value, result, result.result.unfiltered.length, result.result.filtered.map((f) => {
                        //     return f.length;
                        // }));
                        $(qbElementSelector).NetworkappQueryBuilder(
                            'setPreviews',
                            result.result.unfiltered.length,
                            result.result.filtered.map(function (f) {
                                return f.length;
                            })
                        );
                        PREVIEW = _.last(result.result.filtered);
                    })
                    .fail(function () {
                        console.error(arguments);
                        PREVIEW = [];
                    });
            };
        },
        useParticipantsPreviewComponent: function (qbElementSelector, previewComponent, previewURL) {
            return function (value) {
                $.ajax({
                    method: 'POST',
                    url: previewURL,
                    data: {
                        filter: JSON.stringify(value),
                    },
                })
                    .done(function (result) {
                        // console.log(value, result, result.result.unfiltered.length, result.result.filtered.map((f) => {
                        //     return f.length;
                        // }));
                        $(qbElementSelector).NetworkappQueryBuilder(
                            'setPreviews',
                            result.result.unfiltered.length,
                            result.result.filtered.map(function (f) {
                                return f.length;
                            })
                        );
                        previewComponent.setValues(_.last(result.result.filtered));
                    })
                    .fail(function () {
                        console.error(arguments);
                        previewComponent.setValues([]);
                    });
            };
        },
    },
};
